import { AudioLines, Youtube, Linkedin, Instagram, Twitter } from "lucide-react";

const SOCIALS = [
  { icon: Youtube, label: "YouTube", href: "https://youtube.com/@speakerankush" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/ankushmehrotra/" },
  { icon: Instagram, label: "Instagram", href: "https://instagram.com/speakerankush" },
  { icon: Twitter, label: "Twitter", href: "https://twitter.com/speakerankush" },
];

const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 pt-14 sm:pt-20 pb-8 sm:pb-12 px-4 overflow-hidden">
      <h2
        data-testid="footer-branding"
        className="text-center font-display font-extrabold uppercase tracking-tight leading-none outline-massive text-[16vw] sm:text-[13vw] lg:text-[8.5rem] select-none"
      >
        Keep Roaring.
      </h2>

      <div className="max-w-7xl mx-auto mt-10 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-2xl clay-badge flex items-center justify-center">
              <AudioLines className="w-4 h-4 text-amber-400" />
            </span>
            <span className="font-display font-extrabold tracking-tight text-lg">
              My<span className="text-gold-gradient">IQ</span> Talks
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
            My Income Quotient — open-ended conversations on money, growth and the humans
            behind both. Hosted by Ankush Mehrotra.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-slate-500">Explore</p>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["The Host", "#host"],
              ["Guest Dimensions", "#guest-dimensions"],
              ["The Pitch", "#the-pitch"],
              ["Request a Slot", "#request-slot"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="text-slate-400 hover:text-amber-300 transition-colors">{label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-slate-500">Follow the Show</p>
          <div data-testid="footer-social-links" className="mt-5 flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="clay-badge w-11 h-11 rounded-2xl flex items-center justify-center text-slate-300 hover:text-amber-300 hover:-translate-y-1 transition-all duration-300"
              >
                <s.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 sm:mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
        <p className="text-xs text-slate-600">© 2026 MyIQ Talks · An Ankush Mehrotra Production</p>
        <p className="text-xs text-slate-600">Recorded with candour. Shared with respect.</p>
      </div>
    </footer>
  );
};

export default Footer;
